"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeId = void 0;
const query_string_1 = __importDefault(require("query-string"));
const regex = /https?:\/\/youtu\.be\/([^?]+)/g;
exports.getYoutubeId = (url) => {
    if (!url) {
        return "";
    }
    const trimmedUrl = url.trim();
    if (trimmedUrl.startsWith("https://youtu.be")) {
        let m;
        if ((m = regex.exec(trimmedUrl)) !== null) {
            return m[1] || "";
        }
    }
    else if (trimmedUrl.includes("youtube.com")) {
        try {
            const { query: { v }, } = query_string_1.default.parseUrl(trimmedUrl);
            if (typeof v === "string") {
                return v;
            }
        }
        catch (_a) { }
    }
    return "";
};
//# sourceMappingURL=getYoutubeId.js.map